import styled from 'styled-components'
import Media from 'builder/styles/media'

export const ResumeDistributionLayoutContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${Media.AboveTablet`
      flex-direction: row;
      gap: 128px;
  `}
`

export const ContentContainer = styled.div`
  height: 100%;
  padding: 20px 20px 0;

  ${Media.AboveTablet`
      flex-direction: row;
      padding: 0;
  `}
`

export const ImageContainer = styled.div`
  display: flex;
  flex-shrink: 0;
`

export const Image = styled.img`
  width: 544px;
  height: 560px;
  flex-shrink: 0;
`
